import _toConsumableArray from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectWithoutProperties from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/createClass.js";
var _excluded = ["limit"],
  _excluded2 = ["signal"];
import _regeneratorRuntime from "/codebuild/output/src856819620/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import "core-js/modules/esnext.global-this.js";
var __defProp = Object.defineProperty;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __publicField = function __publicField(obj, key, value) {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import * as prismicH from "@prismicio/helpers";
import { appendPredicates } from "./lib/appendPredicates.js";
import { castArray } from "./lib/castArray.js";
import { castThunk } from "./lib/castThunk.js";
import { findMasterRef } from "./lib/findMasterRef.js";
import { findRefByID } from "./lib/findRefByID.js";
import { findRefByLabel } from "./lib/findRefByLabel.js";
import { getPreviewCookie } from "./lib/getPreviewCookie.js";
import { minifyGraphQLQuery } from "./lib/minifyGraphQLQuery.js";
import { ForbiddenError } from "./ForbiddenError.js";
import { NotFoundError } from "./NotFoundError.js";
import { ParsingError } from "./ParsingError.js";
import { PrismicError } from "./PrismicError.js";
import { buildQueryURL as _buildQueryURL } from "./buildQueryURL.js";
import { getRepositoryEndpoint } from "./getRepositoryEndpoint.js";
import { isRepositoryEndpoint } from "./isRepositoryEndpoint.js";
import { predicate } from "./predicate.js";
var MAX_PAGE_SIZE = 100;
var REPOSITORY_CACHE_TTL = 5e3;
var GET_ALL_QUERY_DELAY = 500;
var RefStateMode;
(function (RefStateMode2) {
  RefStateMode2["Master"] = "Master";
  RefStateMode2["ReleaseID"] = "ReleaseID";
  RefStateMode2["ReleaseLabel"] = "ReleaseLabel";
  RefStateMode2["Manual"] = "Manual";
})(RefStateMode || (RefStateMode = {}));
var typePredicate = function typePredicate(documentType) {
  return predicate.at("document.type", documentType);
};
var everyTagPredicate = function everyTagPredicate(tags) {
  return predicate.at("document.tags", castArray(tags));
};
var someTagsPredicate = function someTagsPredicate(tags) {
  return predicate.any("document.tags", castArray(tags));
};
var createClient = function createClient(repositoryNameOrEndpoint, options) {
  return new Client(repositoryNameOrEndpoint, options);
};
var Client = /*#__PURE__*/function () {
  function Client(repositoryNameOrEndpoint) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, Client);
    __publicField(this, "endpoint");
    __publicField(this, "accessToken");
    __publicField(this, "routes");
    __publicField(this, "brokenRoute");
    __publicField(this, "fetchFn");
    __publicField(this, "defaultParams");
    __publicField(this, "refState", {
      mode: RefStateMode.Master,
      autoPreviewsEnabled: true
    });
    __publicField(this, "cachedRepository");
    __publicField(this, "cachedRepositoryExpiration", 0);
    __publicField(this, "graphqlFetch", this.graphQLFetch.bind(this));
    if (isRepositoryEndpoint(repositoryNameOrEndpoint)) {
      if (process.env.NODE_ENV === "development" && /\.prismic\.io\/(?!api\/v2\/?)/.test(repositoryNameOrEndpoint)) {
        throw new PrismicError("@prismicio/client only supports Prismic Rest API V2. Please provide only the repository name to the first createClient() parameter or use the getRepositoryEndpoint() helper to generate a valid Rest API V2 endpoint URL.", void 0, void 0);
      }
      this.endpoint = repositoryNameOrEndpoint;
    } else {
      this.endpoint = getRepositoryEndpoint(repositoryNameOrEndpoint);
    }
    this.accessToken = options.accessToken;
    this.routes = options.routes;
    this.brokenRoute = options.brokenRoute;
    this.defaultParams = options.defaultParams;
    if (options.ref) {
      this.queryContentFromRef(options.ref);
    }
    if (typeof options.fetch === "function") {
      this.fetchFn = options.fetch;
    } else if (typeof globalThis.fetch === "function") {
      this.fetchFn = globalThis.fetch;
    } else {
      throw new PrismicError("A valid fetch implementation was not provided. In environments where fetch is not available (including Node.js), a fetch implementation must be provided via a polyfill or the `fetch` option.", void 0, void 0);
    }
    if (this.fetchFn === globalThis.fetch) {
      this.fetchFn = this.fetchFn.bind(globalThis);
    }
    this.graphQLFetch = this.graphQLFetch.bind(this);
  }
  _createClass(Client, [{
    key: "enableAutoPreviews",
    value: function enableAutoPreviews() {
      this.refState.autoPreviewsEnabled = true;
    }
  }, {
    key: "enableAutoPreviewsFromReq",
    value: function enableAutoPreviewsFromReq(req) {
      this.refState.httpRequest = req;
      this.refState.autoPreviewsEnabled = true;
    }
  }, {
    key: "disableAutoPreviews",
    value: function disableAutoPreviews() {
      this.refState.autoPreviewsEnabled = false;
    }
  }, {
    key: "query",
    value: function () {
      var _query = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(predicates, params) {
        var url;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.buildQueryURL(_objectSpread(_objectSpread({}, params), {}, {
                predicates: predicates
              }));
            case 2:
              url = _context.sent;
              _context.next = 5;
              return this.fetch(url, params);
            case 5:
              return _context.abrupt("return", _context.sent);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function query(_x, _x2) {
        return _query.apply(this, arguments);
      }
      return query;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(params) {
        var url;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.buildQueryURL(params);
            case 2:
              url = _context2.sent;
              _context2.next = 5;
              return this.fetch(url, params);
            case 5:
              return _context2.abrupt("return", _context2.sent);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function get(_x3) {
        return _get.apply(this, arguments);
      }
      return get;
    }()
  }, {
    key: "getFirst",
    value: function () {
      var _getFirst = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(params) {
        var _a, actualParams, _ref, url, result, firstResult;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              actualParams = _objectSpread({}, params);
              if (!(params && params.page) && !(params == null ? void 0 : params.pageSize)) {
                actualParams.pageSize = (_ref = (_a = this.defaultParams) == null ? void 0 : _a.pageSize) !== null && _ref !== void 0 ? _ref : 1;
              }
              _context3.next = 4;
              return this.buildQueryURL(actualParams);
            case 4:
              url = _context3.sent;
              _context3.next = 7;
              return this.fetch(url, params);
            case 7:
              result = _context3.sent;
              firstResult = result.results[0];
              if (!firstResult) {
                _context3.next = 11;
                break;
              }
              return _context3.abrupt("return", firstResult);
            case 11:
              throw new PrismicError("No documents were returned", url, void 0);
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getFirst(_x4) {
        return _getFirst.apply(this, arguments);
      }
      return getFirst;
    }()
  }, {
    key: "dangerouslyGetAll",
    value: function () {
      var _dangerouslyGetAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var params,
          _a,
          _params$limit,
          limit,
          actualParams,
          resolvedParams,
          documents,
          latestResult,
          page,
          _args4 = arguments;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              params = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : {};
              _params$limit = params.limit, limit = _params$limit === void 0 ? Infinity : _params$limit, actualParams = _objectWithoutProperties(params, _excluded);
              resolvedParams = _objectSpread(_objectSpread({}, actualParams), {}, {
                pageSize: Math.min(limit, actualParams.pageSize || ((_a = this.defaultParams) == null ? void 0 : _a.pageSize) || MAX_PAGE_SIZE)
              });
              documents = [];
            case 4:
              if (!((!latestResult || latestResult.next_page) && documents.length < limit)) {
                _context4.next = 15;
                break;
              }
              page = latestResult ? latestResult.page + 1 : void 0;
              _context4.next = 8;
              return this.get(_objectSpread(_objectSpread({}, resolvedParams), {}, {
                page: page
              }));
            case 8:
              latestResult = _context4.sent;
              documents.push.apply(documents, _toConsumableArray(latestResult.results));
              if (!latestResult.next_page) {
                _context4.next = 13;
                break;
              }
              _context4.next = 13;
              return new Promise(function (res) {
                return setTimeout(res, GET_ALL_QUERY_DELAY);
              });
            case 13:
              _context4.next = 4;
              break;
            case 15:
              return _context4.abrupt("return", documents.slice(0, limit));
            case 16:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function dangerouslyGetAll() {
        return _dangerouslyGetAll.apply(this, arguments);
      }
      return dangerouslyGetAll;
    }()
  }, {
    key: "getByID",
    value: function () {
      var _getByID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id, params) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return this.getFirst(appendPredicates(params, predicate.at("document.id", id)));
            case 2:
              return _context5.abrupt("return", _context5.sent);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getByID(_x5, _x6) {
        return _getByID.apply(this, arguments);
      }
      return getByID;
    }()
  }, {
    key: "getByIDs",
    value: function () {
      var _getByIDs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(ids, params) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.get(appendPredicates(params, predicate.in("document.id", ids)));
            case 2:
              return _context6.abrupt("return", _context6.sent);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getByIDs(_x7, _x8) {
        return _getByIDs.apply(this, arguments);
      }
      return getByIDs;
    }()
  }, {
    key: "getAllByIDs",
    value: function () {
      var _getAllByIDs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(ids, params) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.dangerouslyGetAll(appendPredicates(params, predicate.in("document.id", ids)));
            case 2:
              return _context7.abrupt("return", _context7.sent);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getAllByIDs(_x9, _x10) {
        return _getAllByIDs.apply(this, arguments);
      }
      return getAllByIDs;
    }()
  }, {
    key: "getByUID",
    value: function () {
      var _getByUID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(documentType, uid, params) {
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.getFirst(appendPredicates(params, [typePredicate(documentType), predicate.at("my.".concat(documentType, ".uid"), uid)]));
            case 2:
              return _context8.abrupt("return", _context8.sent);
            case 3:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getByUID(_x11, _x12, _x13) {
        return _getByUID.apply(this, arguments);
      }
      return getByUID;
    }()
  }, {
    key: "getByUIDs",
    value: function () {
      var _getByUIDs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(documentType, uids, params) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.get(appendPredicates(params, [typePredicate(documentType), predicate.in("my.".concat(documentType, ".uid"), uids)]));
            case 2:
              return _context9.abrupt("return", _context9.sent);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getByUIDs(_x14, _x15, _x16) {
        return _getByUIDs.apply(this, arguments);
      }
      return getByUIDs;
    }()
  }, {
    key: "getAllByUIDs",
    value: function () {
      var _getAllByUIDs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(documentType, uids, params) {
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.dangerouslyGetAll(appendPredicates(params, [typePredicate(documentType), predicate.in("my.".concat(documentType, ".uid"), uids)]));
            case 2:
              return _context10.abrupt("return", _context10.sent);
            case 3:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function getAllByUIDs(_x17, _x18, _x19) {
        return _getAllByUIDs.apply(this, arguments);
      }
      return getAllByUIDs;
    }()
  }, {
    key: "getSingle",
    value: function () {
      var _getSingle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(documentType, params) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return this.getFirst(appendPredicates(params, typePredicate(documentType)));
            case 2:
              return _context11.abrupt("return", _context11.sent);
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function getSingle(_x20, _x21) {
        return _getSingle.apply(this, arguments);
      }
      return getSingle;
    }()
  }, {
    key: "getByType",
    value: function () {
      var _getByType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(documentType, params) {
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return this.get(appendPredicates(params, typePredicate(documentType)));
            case 2:
              return _context12.abrupt("return", _context12.sent);
            case 3:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getByType(_x22, _x23) {
        return _getByType.apply(this, arguments);
      }
      return getByType;
    }()
  }, {
    key: "getAllByType",
    value: function () {
      var _getAllByType = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(documentType, params) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return this.dangerouslyGetAll(appendPredicates(params, typePredicate(documentType)));
            case 2:
              return _context13.abrupt("return", _context13.sent);
            case 3:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function getAllByType(_x24, _x25) {
        return _getAllByType.apply(this, arguments);
      }
      return getAllByType;
    }()
  }, {
    key: "getByTag",
    value: function () {
      var _getByTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(tag, params) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return this.get(appendPredicates(params, someTagsPredicate(tag)));
            case 2:
              return _context14.abrupt("return", _context14.sent);
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee14, this);
      }));
      function getByTag(_x26, _x27) {
        return _getByTag.apply(this, arguments);
      }
      return getByTag;
    }()
  }, {
    key: "getAllByTag",
    value: function () {
      var _getAllByTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(tag, params) {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return this.dangerouslyGetAll(appendPredicates(params, someTagsPredicate(tag)));
            case 2:
              return _context15.abrupt("return", _context15.sent);
            case 3:
            case "end":
              return _context15.stop();
          }
        }, _callee15, this);
      }));
      function getAllByTag(_x28, _x29) {
        return _getAllByTag.apply(this, arguments);
      }
      return getAllByTag;
    }()
  }, {
    key: "getByEveryTag",
    value: function () {
      var _getByEveryTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(tags, params) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return this.get(appendPredicates(params, everyTagPredicate(tags)));
            case 2:
              return _context16.abrupt("return", _context16.sent);
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16, this);
      }));
      function getByEveryTag(_x30, _x31) {
        return _getByEveryTag.apply(this, arguments);
      }
      return getByEveryTag;
    }()
  }, {
    key: "getAllByEveryTag",
    value: function () {
      var _getAllByEveryTag = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(tags, params) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.dangerouslyGetAll(appendPredicates(params, everyTagPredicate(tags)));
            case 2:
              return _context17.abrupt("return", _context17.sent);
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function getAllByEveryTag(_x32, _x33) {
        return _getAllByEveryTag.apply(this, arguments);
      }
      return getAllByEveryTag;
    }()
  }, {
    key: "getBySomeTags",
    value: function () {
      var _getBySomeTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(tags, params) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.next = 2;
              return this.get(appendPredicates(params, someTagsPredicate(tags)));
            case 2:
              return _context18.abrupt("return", _context18.sent);
            case 3:
            case "end":
              return _context18.stop();
          }
        }, _callee18, this);
      }));
      function getBySomeTags(_x34, _x35) {
        return _getBySomeTags.apply(this, arguments);
      }
      return getBySomeTags;
    }()
  }, {
    key: "getAllBySomeTags",
    value: function () {
      var _getAllBySomeTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(tags, params) {
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return this.dangerouslyGetAll(appendPredicates(params, someTagsPredicate(tags)));
            case 2:
              return _context19.abrupt("return", _context19.sent);
            case 3:
            case "end":
              return _context19.stop();
          }
        }, _callee19, this);
      }));
      function getAllBySomeTags(_x36, _x37) {
        return _getAllBySomeTags.apply(this, arguments);
      }
      return getAllBySomeTags;
    }()
  }, {
    key: "getRepository",
    value: function () {
      var _getRepository = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(params) {
        var url;
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              url = new URL(this.endpoint);
              if (this.accessToken) {
                url.searchParams.set("access_token", this.accessToken);
              }
              _context20.next = 4;
              return this.fetch(url.toString(), params);
            case 4:
              return _context20.abrupt("return", _context20.sent);
            case 5:
            case "end":
              return _context20.stop();
          }
        }, _callee20, this);
      }));
      function getRepository(_x38) {
        return _getRepository.apply(this, arguments);
      }
      return getRepository;
    }()
  }, {
    key: "getRefs",
    value: function () {
      var _getRefs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(params) {
        var repository;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.next = 2;
              return this.getRepository(params);
            case 2:
              repository = _context21.sent;
              return _context21.abrupt("return", repository.refs);
            case 4:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this);
      }));
      function getRefs(_x39) {
        return _getRefs.apply(this, arguments);
      }
      return getRefs;
    }()
  }, {
    key: "getRefByID",
    value: function () {
      var _getRefByID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(id, params) {
        var refs;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.next = 2;
              return this.getRefs(params);
            case 2:
              refs = _context22.sent;
              return _context22.abrupt("return", findRefByID(refs, id));
            case 4:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this);
      }));
      function getRefByID(_x40, _x41) {
        return _getRefByID.apply(this, arguments);
      }
      return getRefByID;
    }()
  }, {
    key: "getRefByLabel",
    value: function () {
      var _getRefByLabel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(label, params) {
        var refs;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.next = 2;
              return this.getRefs(params);
            case 2:
              refs = _context23.sent;
              return _context23.abrupt("return", findRefByLabel(refs, label));
            case 4:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this);
      }));
      function getRefByLabel(_x42, _x43) {
        return _getRefByLabel.apply(this, arguments);
      }
      return getRefByLabel;
    }()
  }, {
    key: "getMasterRef",
    value: function () {
      var _getMasterRef = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(params) {
        var refs;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.next = 2;
              return this.getRefs(params);
            case 2:
              refs = _context24.sent;
              return _context24.abrupt("return", findMasterRef(refs));
            case 4:
            case "end":
              return _context24.stop();
          }
        }, _callee24, this);
      }));
      function getMasterRef(_x44) {
        return _getMasterRef.apply(this, arguments);
      }
      return getMasterRef;
    }()
  }, {
    key: "getReleases",
    value: function () {
      var _getReleases = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(params) {
        var refs;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) switch (_context25.prev = _context25.next) {
            case 0:
              _context25.next = 2;
              return this.getRefs(params);
            case 2:
              refs = _context25.sent;
              return _context25.abrupt("return", refs.filter(function (ref) {
                return !ref.isMasterRef;
              }));
            case 4:
            case "end":
              return _context25.stop();
          }
        }, _callee25, this);
      }));
      function getReleases(_x45) {
        return _getReleases.apply(this, arguments);
      }
      return getReleases;
    }()
  }, {
    key: "getReleaseByID",
    value: function () {
      var _getReleaseByID = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(id, params) {
        var releases;
        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) switch (_context26.prev = _context26.next) {
            case 0:
              _context26.next = 2;
              return this.getReleases(params);
            case 2:
              releases = _context26.sent;
              return _context26.abrupt("return", findRefByID(releases, id));
            case 4:
            case "end":
              return _context26.stop();
          }
        }, _callee26, this);
      }));
      function getReleaseByID(_x46, _x47) {
        return _getReleaseByID.apply(this, arguments);
      }
      return getReleaseByID;
    }()
  }, {
    key: "getReleaseByLabel",
    value: function () {
      var _getReleaseByLabel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(label, params) {
        var releases;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              _context27.next = 2;
              return this.getReleases(params);
            case 2:
              releases = _context27.sent;
              return _context27.abrupt("return", findRefByLabel(releases, label));
            case 4:
            case "end":
              return _context27.stop();
          }
        }, _callee27, this);
      }));
      function getReleaseByLabel(_x48, _x49) {
        return _getReleaseByLabel.apply(this, arguments);
      }
      return getReleaseByLabel;
    }()
  }, {
    key: "getTags",
    value: function () {
      var _getTags = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(params) {
        var tagsForm, url, repository;
        return _regeneratorRuntime.wrap(function _callee28$(_context28) {
          while (1) switch (_context28.prev = _context28.next) {
            case 0:
              _context28.prev = 0;
              _context28.next = 3;
              return this.getCachedRepositoryForm("tags", params);
            case 3:
              tagsForm = _context28.sent;
              url = new URL(tagsForm.action);
              if (this.accessToken) {
                url.searchParams.set("access_token", this.accessToken);
              }
              _context28.next = 8;
              return this.fetch(url.toString(), params);
            case 8:
              return _context28.abrupt("return", _context28.sent);
            case 11:
              _context28.prev = 11;
              _context28.t0 = _context28["catch"](0);
              _context28.next = 15;
              return this.getRepository(params);
            case 15:
              repository = _context28.sent;
              return _context28.abrupt("return", repository.tags);
            case 17:
            case "end":
              return _context28.stop();
          }
        }, _callee28, this, [[0, 11]]);
      }));
      function getTags(_x50) {
        return _getTags.apply(this, arguments);
      }
      return getTags;
    }()
  }, {
    key: "buildQueryURL",
    value: function () {
      var _buildQueryURL2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        var _ref2,
          signal,
          params,
          ref,
          integrationFieldsRef,
          _args29 = arguments;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) switch (_context29.prev = _context29.next) {
            case 0:
              _ref2 = _args29.length > 0 && _args29[0] !== undefined ? _args29[0] : {}, signal = _ref2.signal, params = _objectWithoutProperties(_ref2, _excluded2);
              _context29.t0 = params.ref;
              if (_context29.t0) {
                _context29.next = 6;
                break;
              }
              _context29.next = 5;
              return this.getResolvedRefString();
            case 5:
              _context29.t0 = _context29.sent;
            case 6:
              ref = _context29.t0;
              _context29.t2 = params.integrationFieldsRef;
              if (_context29.t2) {
                _context29.next = 12;
                break;
              }
              _context29.next = 11;
              return this.getCachedRepository({
                signal: signal
              });
            case 11:
              _context29.t2 = _context29.sent.integrationFieldsRef;
            case 12:
              _context29.t1 = _context29.t2;
              if (_context29.t1) {
                _context29.next = 15;
                break;
              }
              _context29.t1 = void 0;
            case 15:
              integrationFieldsRef = _context29.t1;
              return _context29.abrupt("return", _buildQueryURL(this.endpoint, _objectSpread(_objectSpread(_objectSpread({}, this.defaultParams), params), {}, {
                ref: ref,
                integrationFieldsRef: integrationFieldsRef,
                routes: params.routes || this.routes,
                brokenRoute: params.brokenRoute || this.brokenRoute,
                accessToken: params.accessToken || this.accessToken
              })));
            case 17:
            case "end":
              return _context29.stop();
          }
        }, _callee29, this);
      }));
      function buildQueryURL() {
        return _buildQueryURL2.apply(this, arguments);
      }
      return buildQueryURL;
    }()
  }, {
    key: "resolvePreviewURL",
    value: function () {
      var _resolvePreviewURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(args) {
        var _a, _b, documentID, previewToken, searchParams, _searchParams, document, url;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) switch (_context30.prev = _context30.next) {
            case 0:
              documentID = args.documentID;
              previewToken = args.previewToken;
              if (typeof globalThis.location !== "undefined") {
                searchParams = new URLSearchParams(globalThis.location.search);
                documentID = documentID || searchParams.get("documentId");
                previewToken = previewToken || searchParams.get("token");
              } else if (this.refState.httpRequest) {
                if ("query" in this.refState.httpRequest) {
                  documentID = documentID || ((_a = this.refState.httpRequest.query) == null ? void 0 : _a.documentId);
                  previewToken = previewToken || ((_b = this.refState.httpRequest.query) == null ? void 0 : _b.token);
                } else if ("url" in this.refState.httpRequest && this.refState.httpRequest.url) {
                  _searchParams = new URL(this.refState.httpRequest.url).searchParams;
                  documentID = documentID || _searchParams.get("documentId");
                  previewToken = previewToken || _searchParams.get("token");
                }
              }
              if (!(documentID != null && previewToken != null)) {
                _context30.next = 10;
                break;
              }
              _context30.next = 6;
              return this.getByID(documentID, {
                signal: args.signal,
                ref: previewToken,
                lang: "*"
              });
            case 6:
              document = _context30.sent;
              url = prismicH.asLink(document, args.linkResolver);
              if (!(typeof url === "string")) {
                _context30.next = 10;
                break;
              }
              return _context30.abrupt("return", url);
            case 10:
              return _context30.abrupt("return", args.defaultURL);
            case 11:
            case "end":
              return _context30.stop();
          }
        }, _callee30, this);
      }));
      function resolvePreviewURL(_x51) {
        return _resolvePreviewURL.apply(this, arguments);
      }
      return resolvePreviewURL;
    }()
  }, {
    key: "queryLatestContent",
    value: function queryLatestContent() {
      this.refState.mode = RefStateMode.Master;
    }
  }, {
    key: "queryContentFromReleaseByID",
    value: function queryContentFromReleaseByID(releaseID) {
      this.refState = _objectSpread(_objectSpread({}, this.refState), {}, {
        mode: RefStateMode.ReleaseID,
        releaseID: releaseID
      });
    }
  }, {
    key: "queryContentFromReleaseByLabel",
    value: function queryContentFromReleaseByLabel(releaseLabel) {
      this.refState = _objectSpread(_objectSpread({}, this.refState), {}, {
        mode: RefStateMode.ReleaseLabel,
        releaseLabel: releaseLabel
      });
    }
  }, {
    key: "queryContentFromRef",
    value: function queryContentFromRef(ref) {
      this.refState = _objectSpread(_objectSpread({}, this.refState), {}, {
        mode: RefStateMode.Manual,
        ref: ref
      });
    }
  }, {
    key: "graphQLFetch",
    value: function () {
      var _graphQLFetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(input, init) {
        var cachedRepository, ref, unsanitizedHeaders, headers, key, url, query;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) switch (_context31.prev = _context31.next) {
            case 0:
              _context31.next = 2;
              return this.getCachedRepository();
            case 2:
              cachedRepository = _context31.sent;
              _context31.next = 5;
              return this.getResolvedRefString();
            case 5:
              ref = _context31.sent;
              unsanitizedHeaders = _objectSpread({
                "Prismic-ref": ref,
                Authorization: this.accessToken ? "Token ".concat(this.accessToken) : ""
              }, init ? init.headers : {});
              if (cachedRepository.integrationFieldsRef) {
                unsanitizedHeaders["Prismic-integration-field-ref"] = cachedRepository.integrationFieldsRef;
              }
              headers = {};
              for (key in unsanitizedHeaders) {
                if (unsanitizedHeaders[key]) {
                  headers[key.toLowerCase()] = unsanitizedHeaders[key];
                }
              }
              url = new URL(input);
              url.searchParams.set("ref", ref);
              query = url.searchParams.get("query");
              if (query) {
                url.searchParams.set("query", minifyGraphQLQuery(query));
              }
              _context31.next = 16;
              return this.fetchFn(url.toString(), _objectSpread(_objectSpread({}, init), {}, {
                headers: headers
              }));
            case 16:
              return _context31.abrupt("return", _context31.sent);
            case 17:
            case "end":
              return _context31.stop();
          }
        }, _callee31, this);
      }));
      function graphQLFetch(_x52, _x53) {
        return _graphQLFetch.apply(this, arguments);
      }
      return graphQLFetch;
    }()
  }, {
    key: "getCachedRepository",
    value: function () {
      var _getCachedRepository = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(params) {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) switch (_context32.prev = _context32.next) {
            case 0:
              if (!(!this.cachedRepository || Date.now() >= this.cachedRepositoryExpiration)) {
                _context32.next = 5;
                break;
              }
              this.cachedRepositoryExpiration = Date.now() + REPOSITORY_CACHE_TTL;
              _context32.next = 4;
              return this.getRepository(params);
            case 4:
              this.cachedRepository = _context32.sent;
            case 5:
              return _context32.abrupt("return", this.cachedRepository);
            case 6:
            case "end":
              return _context32.stop();
          }
        }, _callee32, this);
      }));
      function getCachedRepository(_x54) {
        return _getCachedRepository.apply(this, arguments);
      }
      return getCachedRepository;
    }()
  }, {
    key: "getCachedRepositoryForm",
    value: function () {
      var _getCachedRepositoryForm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(name, params) {
        var cachedRepository, form;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) switch (_context33.prev = _context33.next) {
            case 0:
              _context33.next = 2;
              return this.getCachedRepository(params);
            case 2:
              cachedRepository = _context33.sent;
              form = cachedRepository.forms[name];
              if (form) {
                _context33.next = 6;
                break;
              }
              throw new PrismicError("Form with name \"".concat(name, "\" could not be found"), void 0, void 0);
            case 6:
              return _context33.abrupt("return", form);
            case 7:
            case "end":
              return _context33.stop();
          }
        }, _callee33, this);
      }));
      function getCachedRepositoryForm(_x55, _x56) {
        return _getCachedRepositoryForm.apply(this, arguments);
      }
      return getCachedRepositoryForm;
    }()
  }, {
    key: "getResolvedRefString",
    value: function () {
      var _getResolvedRefString = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(params) {
        var _a, _b, previewRef, cookieJar, cachedRepository, refModeType, res;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) switch (_context34.prev = _context34.next) {
            case 0:
              if (!this.refState.autoPreviewsEnabled) {
                _context34.next = 5;
                break;
              }
              if ((_a = this.refState.httpRequest) == null ? void 0 : _a.headers) {
                if ("get" in this.refState.httpRequest.headers && typeof this.refState.httpRequest.headers.get === "function") {
                  cookieJar = this.refState.httpRequest.headers.get("cookie");
                } else if ("cookie" in this.refState.httpRequest.headers) {
                  cookieJar = this.refState.httpRequest.headers.cookie;
                }
              } else if ((_b = globalThis.document) == null ? void 0 : _b.cookie) {
                cookieJar = globalThis.document.cookie;
              }
              if (cookieJar) {
                previewRef = getPreviewCookie(cookieJar);
              }
              if (!previewRef) {
                _context34.next = 5;
                break;
              }
              return _context34.abrupt("return", previewRef);
            case 5:
              _context34.next = 7;
              return this.getCachedRepository(params);
            case 7:
              cachedRepository = _context34.sent;
              refModeType = this.refState.mode;
              if (!(refModeType === RefStateMode.ReleaseID)) {
                _context34.next = 13;
                break;
              }
              return _context34.abrupt("return", findRefByID(cachedRepository.refs, this.refState.releaseID).ref);
            case 13:
              if (!(refModeType === RefStateMode.ReleaseLabel)) {
                _context34.next = 17;
                break;
              }
              return _context34.abrupt("return", findRefByLabel(cachedRepository.refs, this.refState.releaseLabel).ref);
            case 17:
              if (!(refModeType === RefStateMode.Manual)) {
                _context34.next = 23;
                break;
              }
              _context34.next = 20;
              return castThunk(this.refState.ref)();
            case 20:
              res = _context34.sent;
              if (!(typeof res === "string")) {
                _context34.next = 23;
                break;
              }
              return _context34.abrupt("return", res);
            case 23:
              return _context34.abrupt("return", findMasterRef(cachedRepository.refs).ref);
            case 24:
            case "end":
              return _context34.stop();
          }
        }, _callee34, this);
      }));
      function getResolvedRefString(_x57) {
        return _getResolvedRefString.apply(this, arguments);
      }
      return getResolvedRefString;
    }()
  }, {
    key: "fetch",
    value: function () {
      var _fetch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(url) {
        var params,
          res,
          json,
          _args35 = arguments;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) switch (_context35.prev = _context35.next) {
            case 0:
              params = _args35.length > 1 && _args35[1] !== undefined ? _args35[1] : {};
              _context35.next = 3;
              return this.fetchFn(url, {
                signal: params.signal
              });
            case 3:
              res = _context35.sent;
              _context35.prev = 4;
              _context35.next = 7;
              return res.json();
            case 7:
              json = _context35.sent;
              _context35.next = 17;
              break;
            case 10:
              _context35.prev = 10;
              _context35.t0 = _context35["catch"](4);
              if (!(res.status === 404)) {
                _context35.next = 16;
                break;
              }
              throw new NotFoundError("Prismic repository not found. Check that \"".concat(this.endpoint, "\" is pointing to the correct repository."), url, void 0);
            case 16:
              throw new PrismicError(void 0, url, void 0);
            case 17:
              _context35.t1 = res.status;
              _context35.next = _context35.t1 === 200 ? 20 : _context35.t1 === 400 ? 21 : _context35.t1 === 401 ? 22 : _context35.t1 === 403 ? 22 : 23;
              break;
            case 20:
              return _context35.abrupt("return", json);
            case 21:
              throw new ParsingError(json.message, url, json);
            case 22:
              throw new ForbiddenError("error" in json ? json.error : json.message, url, json);
            case 23:
              throw new PrismicError(void 0, url, json);
            case 24:
            case "end":
              return _context35.stop();
          }
        }, _callee35, this, [[4, 10]]);
      }));
      function fetch(_x58) {
        return _fetch.apply(this, arguments);
      }
      return fetch;
    }()
  }]);
  return Client;
}();
export { Client, GET_ALL_QUERY_DELAY, REPOSITORY_CACHE_TTL, createClient };